module.exports = __webpack_public_path__ + "img/shifts-icon-blue.34816fa5.svg";